import { Component, OnInit } from '@angular/core';
import { FilterSettingsModel, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { PacienteService } from 'src/app/servicos/paciente.service';

@Component({
  selector: 'app-paciente-lotacao-lista',
  templateUrl: './paciente-lotacao-lista.component.html',
  styleUrls: ['./paciente-lotacao-lista.component.less']
})
export class PacienteLotacaoListaComponent implements OnInit {
  
  registros: Object | null = null;

  filterSettings: FilterSettingsModel = {
    mode: 'Immediate',
    type: 'Excel'
  }

  searchSettings: SearchSettingsModel = {
    ignoreAccent: true,
    ignoreCase: true
  }
  
  constructor(private pacienteService: PacienteService) { }

  ngOnInit(): void {

  }

  carregar() {
    this.pacienteService.listarLotacoesAtribuicoes().subscribe((lotacoes) => {
      this.registros = lotacoes;
    });
  }

}
